import { environment } from './../environments/environment';
import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { DataService } from './shared/modules/data-service/services/data.service';

@Injectable()
export class CustomErrorHandler implements ErrorHandler {

  private lastAlerted: string;

  constructor(
    private dataService: DataService,
  ) {}

 
   handleError(error: any) {
    // Guard against empty/primitive rejections
    const real = error?.rejection ?? error?.originalError ?? error?.ngOriginalError ?? error;

    const eventId = Sentry.captureException(
      real instanceof Error ? real : new Error('Non-Error thrown: ' + JSON.stringify(real))
    );

    console.error('*** Error information');
    console.error('raw:', error, 'typeof:', typeof error);
    console.error('resolved:', real);
    console.error('stack:', real?.stack ?? new Error('handler stack').stack);
    console.error('*** End error information');

    // Don't alert in a loop: only once per distinct message
    const key = String(real?.message ?? real);
    if (!environment.production && key !== this.lastAlerted) {
      this.lastAlerted = key;
      alert('Something went wrong, but don\'t worry!\n\nAn error report has been sent to the developers, you should also check your work.\n\nYou may want to reload the page.');
    }
  }

}

